import styled from 'styled-components';

export const StyledPackageItemTile = styled.div`
  width: 100%;
  height: 142px;
  margin-bottom: 16px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.palette.systemGreyMedium};
`;
